
export default [
	{
		path: '/', //首页
		name: 'index',
		component: resolve => require(['@/components/main.vue'], resolve),
	},
	{
		path: '/mainDetail', //行为图分析页面
		name: 'mainDetail',
		component: resolve => require(['@/components/mainIndex/mainDetail.vue'], resolve),
	},
	{
		path: '/behavior', //行为图分析页面
		name: 'behavior',
		component: resolve => require(['@/components/mainIndex/behavior.vue'], resolve),
	},
	{
		path: '/playGame', // 游戏页面
		name: 'playGame',
		component: resolve => require(['@/components/game/playGame'], resolve),
	},
]



// WEBPACK FOOTER //
// ./src/router/mainRouter.js